"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createArrayHandler = void 0;
var addObjectToDataset_1 = require("./helperFunctions/addObjectToDataset");
var objectToJsonRepresentation_1 = require("./helperFunctions/objectToJsonRepresentation");
var data_model_1 = require("@rdfjs/data-model");
var arrayMethods_1 = require("./helperFunctions/arrayMethods");
function getProcessedObjects(dataset, contextUtil, proxyCreator, target) {
    var objects = dataset.match.apply(dataset, __spreadArray([], __read(target[0]), false));
    var datasetObjects = new Set(objects.toArray().map(function (quad) {
        return (0, objectToJsonRepresentation_1.objectToJsonldRepresentation)(quad, dataset, contextUtil, proxyCreator);
    }));
    var processedObjects = [];
    target[1].forEach(function (arrItem) {
        if (datasetObjects.has(arrItem)) {
            processedObjects.push(arrItem);
            datasetObjects.delete(arrItem);
        }
    });
    Array.from(datasetObjects).forEach(function (datasetObject) {
        processedObjects.push(datasetObject);
    });
    target[1] = processedObjects;
    return processedObjects;
}
function createArrayHandler(dataset, contextUtil, proxyCreator) {
    return {
        get: function (target, key) {
            var rest = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                rest[_i - 2] = arguments[_i];
            }
            var processedObjects = getProcessedObjects(dataset, contextUtil, proxyCreator, target);
            if (arrayMethods_1.methodNames.has(key)) {
                return arrayMethods_1.arrayMethodsBuilders[key](target, dataset, contextUtil);
            }
            return Reflect.get.apply(Reflect, __spreadArray([processedObjects, key], __read(rest), false));
        },
        getOwnPropertyDescriptor: function (target, key) {
            var rest = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                rest[_i - 2] = arguments[_i];
            }
            var processedObjects = getProcessedObjects(dataset, contextUtil, proxyCreator, target);
            return Reflect.getOwnPropertyDescriptor.apply(Reflect, __spreadArray([processedObjects, key], __read(rest), false));
        },
        ownKeys: function (target) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            var processedObjects = getProcessedObjects(dataset, contextUtil, proxyCreator, target);
            return Reflect.ownKeys.apply(Reflect, __spreadArray([processedObjects], __read(rest), false));
        },
        getPrototypeOf: function (target) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            var processedObjects = getProcessedObjects(dataset, contextUtil, proxyCreator, target);
            return Reflect.getPrototypeOf.apply(Reflect, __spreadArray([processedObjects], __read(rest), false));
        },
        has: function (target) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            var processedObjects = getProcessedObjects(dataset, contextUtil, proxyCreator, target);
            return Reflect.has.apply(Reflect, __spreadArray([processedObjects], __read(rest), false));
        },
        set: function (target, key, value) {
            var _a;
            var rest = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                rest[_i - 3] = arguments[_i];
            }
            if (typeof key !== "symbol" && !isNaN(parseInt(key))) {
                var objectQuad = dataset.match.apply(dataset, __spreadArray([], __read(target[0]), false)).toArray()[parseInt(key)];
                if (objectQuad) {
                    dataset.delete(objectQuad);
                }
                if (target[0][0] && target[0][1]) {
                    (0, addObjectToDataset_1.addObjectToDataset)((_a = {
                            "@id": target[0][0]
                        },
                        _a[contextUtil.iriToKey(target[0][1].value)] = value,
                        _a), dataset, contextUtil, new Set(), false);
                    return true;
                }
            }
            return Reflect.set.apply(Reflect, __spreadArray([target, key], __read(rest), false));
        },
        deleteProperty: function (target, key) {
            if (typeof key !== "symbol" && !isNaN(parseInt(key))) {
                var objectQuad = dataset.match.apply(dataset, __spreadArray([], __read(target[0]), false)).toArray()[parseInt(key)];
                if (!objectQuad) {
                    return true;
                }
                var term = objectQuad.object;
                if (term.termType === "Literal") {
                    var subject = target[0][0];
                    var predicate = target[0][1];
                    if (subject && predicate) {
                        dataset.delete((0, data_model_1.quad)(subject, predicate, term));
                    }
                    return true;
                }
                else if (term.termType === "NamedNode") {
                    dataset.deleteMatches(term, undefined, undefined);
                    dataset.deleteMatches(undefined, undefined, term);
                    return true;
                }
            }
            return true;
        },
    };
}
exports.createArrayHandler = createArrayHandler;
